var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list.length > 0)?_c('section',{staticClass:"featured-good-list"},[_c('h2',[_vm._v("Лучшие предложения")]),_c('splide',{attrs:{"options":_vm.options}},_vm._l((_vm.list),function(item){return _c('splide-slide',{key:`best-${item.id}`,staticStyle:{"width":"230px"}},[_c('featured-good-list-item',{attrs:{"item":item}})],1)}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }